import PropTypes from 'prop-types';
import React from 'react';
export const TableHead = _ref => {
  let {
    children,
    className,
    dataTest,
    role
  } = _ref;
  return /*#__PURE__*/React.createElement("thead", {
    className: className,
    "data-test": dataTest,
    role: role
  }, children);
};
TableHead.defaultProps = {
  dataTest: 'dhis2-uicore-tablehead'
};
TableHead.propTypes = {
  /** Should be `<TableRowHead>` components */
  children: PropTypes.node,
  className: PropTypes.string,
  dataTest: PropTypes.string,
  role: PropTypes.string
};